<template>
	<div class="physician_visits_schedule_detail ">
		<div class="content">
			<doctorItem :doctor="doctor" showMoney />
		</div>
		<div class="detail bg-white">
			<h2 class="title">可预约时段</h2>
			<SubscribeDate v-model="date.active" :options="date.list" />
			<div class="list">
				<SubscribeDoctorTimeList v-if="list.length" v-model="scheduleId" :list="list" />
				<base-empty v-else desc="暂无排班" :icon="3" label="本日无医生排班"></base-empty>
			</div>
		</div>
		<foot-button>
			<van-button type="primary" block :disabled="(typeof scheduleId) != 'number' " @click="clickSubscribe"
				>下一步</van-button
			>
		</foot-button>
		<SubscribeInfoDialog ref="subscribeInfoDialog" explain="请确认以上预约信息，预约后将无法取消" />
	</div>
</template>

<script>
import SubscribeDoctorTimeList from './components/subscribe-doctor-time-list.vue'
import SubscribeDate from './components/subscribe-date.vue'
import SubscribeInfoDialog from './components/subscribe-info-dialog.vue'
import doctorItem from '../doctor/components/doctor-item.vue'
export default {
    name: 'physicianVisitsScheduleDetail',
    components: { SubscribeDoctorTimeList, SubscribeDate, SubscribeInfoDialog, doctorItem },
    data: () => ({
        date: {
            active: 0,
            list: []
        },
        doctor: {},
        list: [],
        scheduleId: ''
    }),
    computed: {
        // 1:视频；2:语音
        interrogationType () {
            return parseInt(this.$route.query.type)
        },
        patientId () {
            return this.$store.getters['account/getPatientId']
        },
        doctorId () {
            return this.$route.params.id
        }
    },
    created () {
        this.load()
    },
    watch: {
        'date.active' (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getAppointmentDoctorListByDate(this.date.list[newVal])
            }
        }
    },
    methods: {
        async load () {
            const res = await this.$api.doctor.getDoctorInfoById(this.$route.params.id)
            if (!res.code) this.doctor = res.data
            const res2 = await this.$api.physicianVisits.getDoctorAppointmentStatus({
                interrogationType: this.interrogationType,
                patientId: this.patientId,
                doctorId: this.doctorId
            })
            if (!res2.code) {
                const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
                this.$set(this.date, 'active', 0)
                this.$set(this.date, 'list', res2.data.map(item => ({
                    title: this.$moment().format('YYYY-MM-DD') === item.date ? '今天' : weeks[this.$moment(item.date).days()],
                    date: this.$moment(item.date).format('MM-DD'),
                    reqDate: item.date,
                    status: item.isAppointment,
                    list: []
                })))
                await this.getAppointmentDoctorListByDate(this.date.list[this.date.active])
            }
        },
        async getAppointmentDoctorListByDate ({ reqDate }) {
            const res = await this.$api.physicianVisits.getAppointmentDoctorListByDate({
                date: reqDate,
                doctorId: this.doctor.id,
                patientId: this.patientId,
                interrogationType: this.interrogationType,
            })
            if (!res.code) {
                if (res.data.length) {
                    this.list = res.data[0].scheduleDateList ? res.data[0].scheduleDateList.map(val => ({
                        ...val,
                        status: val.canAppointment
                    })) : []
                } else {
                    this.list = []
                }

            }
        },
        clickSubscribe () {
            console.log(this.scheduleId)
            const item = this.list[this.scheduleId]
            // TODO：携带预约信息前往预约页面
            const { videoPrice, voicePrice } = this.doctor
            this.$store.dispatch('consult/consultOrder', {
                params: {
                    doctor: this.doctor,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    price: this.interrogationType == '1' ? videoPrice : voicePrice
                }
            })
            this.$router.push(`/physicianVisits/consult/${item.id}?type=${this.interrogationType}`)

            // 
            // const fIndex = item.startTime.indexOf(' ') + 1
            // let subscribeTime = `${item.startTime.split(' ')[0]} ${item.startTime.substring(fIndex, item.startTime.lastIndexOf(':'))}-${item.endTime.substring(fIndex, item.endTime.lastIndexOf(':'))}`

            // this.$refs.subscribeInfoDialog.init({
            //     scheduleId: item.id,
            //     patientId: this.$store.getters['account/getPatientId'],
            //     patientName: this.$store.getters['account/patientInfo'].name,
            //     doctorName: this.doctor.name,
            //     subscribeTime
            // })
        }
    }
};
</script>

<style scoped lang="less">
.physician_visits_schedule_detail {
	min-height: calc(100vh - 216px);
	> .content {
		padding: 32px 32px 28px 32px;
	}
	> .detail {
		margin: -32px 32px 0 32px;
		border-radius: 16px;
		.title {
			padding: 32px 32px 0;
			font-family: PingFangSC-Medium;
			font-size: 30px;
			font-weight: normal;
			color: #1f2329;
		}
		.list {
			padding: 0 32px;
			.empty_img {
				width: 313px;
				object-fit: contain;
				vertical-align: middle;
			}
		}
	}
}
</style>

<style lang="less">
.physician_visits_schedule_detail {
	.van-empty {
		padding-top: 100px;
		.van-empty__image {
			height: initial;
		}
		.van-empty__description {
			font-family: PingFangSC-Regular;
			font-size: 26px;
			font-weight: normal;
			line-height: 31px;
			color: #8f959e;
		}
	}
}
</style>
